export type FallBackSpinnerProps = {
	className?: string;
};

type defaultFallBackSpinnerProps = {
	className: "",
}

export const defaultProps: defaultFallBackSpinnerProps = {
	className: "",
}
